import axios from "axios"
import ApiConfig from "../config/ApiConfig"

export const assignFormToMember = (payload) => {
    const result = axios.post(ApiConfig.assignFormToMember, payload)
    return result
}

export const assignFormToGroup = (payload) => {
    const result = axios.post(ApiConfig.assignFormToGroup, payload)
    return result
}